<template>
    <TrimInfoModal
            :modalTitle="'Duplicate trim'"
            :btnSubmitTitle="'Duplicate trim'"
            :sendStatus="dataSendStatus"
            :isCreateNew="false"
            :isDuplicate="true"
            :isEdit="false"
            :trimId="trimId"
            :descriptionPreset="description"
            :isSmallTrimPreset="isSmallTrim"
            @formSubmit="duplicateTrim"
    ></TrimInfoModal>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import TrimInfoModal from "./TrimInfoModal";
    
    export default {
        name: "DuplicateTrimModal",
        
        components: {
            TrimInfoModal,
        },

        emits: [
            'newTrimWasAdded',
        ],

        data() {
            return {
                dataSendStatus: false,
            }
        },

        computed: {
            ...mapState('trimInfo', [
                'trimId',
                'description',
                'isSmallTrim',
            ]),

            ...mapState('editor', [
                'points',
            ]),

            ...mapState('paint', [
                'currentPaint',
                'paintSide',
            ]),

            ...mapGetters('trims', [
                'getTrimNameAsUrl',
            ]),

        },

        methods: {
            ...mapActions('trims', [
                'addNewTrim',
            ]),

            async duplicateTrim(trimData) {
                this.dataSendStatus = true;

                let description = trimData.description;
                let isSmallTrim = trimData.isSmallTrim;
                let points = this.points;
                let paintColorId = this.currentPaint?.id || null;
                let paintSide = this.paintSide;

                let trim = {
                    description,
                    isSmallTrim,
                    points,
                    paintColorId,
                    paintSide,
                };

                // need to check if the name is free
                let newAddedTrim = await this.addNewTrim(trim)
                    .finally(() => {
                        this.dataSendStatus = false;
                    });

                // trimId in the route path is used for identify the trim by the route url
                const trimId = newAddedTrim['id'];
                const trimName = newAddedTrim['trimName'];

                // for use the trimId and trimName in the route path is need to convert it in the url format
                const trimNameAsUrl = this.getTrimNameAsUrl(trimId, trimName);

                // navigate to the Editor page
                this.$router.push({ name: 'editor', params: { trimName: trimNameAsUrl } });

                this.$emit('newTrimWasAdded');
            },

        },

    }
</script>

<style scoped>

</style>